// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"196":"fa2ce8ce","297":"deedf5e0"}[chunkId] + ".js";
};